export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/profile', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getAccountNo = async (searchText) => {
    try {
        const result = await get(
            `accounts/account_no${searchText ? `?search=${searchText}` : ''}`,
        );
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getMyTeamInfo = async (query = '') => {
    try {
        const result = await get(`accounts/team_info` + query);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getAccountList = async (searchText) => {
    try {
        const result = await get(
            `accounts${searchText ? `?search=${searchText}` : ''}`,
        );
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getAccountListRow = async (searchText, page, pageLimit) => {
    try {
        const result = await get(
            `accounts/listRow${searchText ? `?search=${searchText}` : ''} ${page ? `&page=${page}` : ''}${pageLimit ? `&limit=${pageLimit}` : ''}`,
        );
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createAccount = async (data) => {
    try {
        const result = await post('accounts', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const sendRegisterMail = async (data) => {
    try {
        const result = await post('accounts/registermail', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const forgetPass = async (data) => {
    try {
        const result = await post('accounts/forgetPass', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const confirmCode = async (data) => {
    try {
        const result = await put('accounts/confirmCode', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateUser = async (id, data) => {
    try {
        const result = await put(`accounts/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateMyProfile = async (data) => {
    try {
        const result = await put(`accounts/me`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteUser = async (id) => {
    try {
        const result = await destroy(`accounts/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setResetPassword = async (id, data) => {
    try {
        const result = await put(`accounts/password/${id}`, data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const changePassword = async (data) => {
    try {
        const result = await put(`accounts/changepassword/1`, data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateUserPackage = async (id, data) => {
    try {
        const result = await put(`accounts/packageChange/${id}`, data);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const addBonus = async (id, data) => {
    try {
        const result = await post(`accounts/addBonus/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateUserDistributor = async (id) => {
    try {
        const result = await put(`accounts/distributor/${id}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
